import React from 'react';

import classNames from 'classnames';

import s from './vistaPlusInfoRow.scss';

type PropsType = {
    title: string;
    info: string | React.ReactElement;
    button?: Maybe<React.ReactElement>;
    className?: string;
};

/**
 * Info row for the Vista Plus cart item
 * @param {PropsType} - props
 * @returns {React.ReactElement} - rendered component
 */
export const VistaPlusInfoRow: React.FC<PropsType> = ({button, className, info, title}) => (
    <div className={classNames(s.row, className)}>
        <span className={s.title}>{title}</span>
        <span>{info}</span>
        {button && (
            <>
                <span className={s.divider}>|</span>
                {button}
            </>
        )}
    </div>
);
